export default function VCAccounting() {
  return <div>VC Accounting content goes here.</div>;
}